/* @flow */

import { rem } from 'polished';

import { borderWidth } from 'src/shared/app/base/style/token/box';
import { borderColor } from '@braindate/ui/lib/token/color';
import { baseFontSize } from '@braindate/ui/lib/token/typography';

export default {
  p: {
    margin: [rem(8, baseFontSize), 0],
  },
  hr: {
    // Show the overflow in Edge and IE
    overflow: 'visible',

    margin: [rem(16, baseFontSize), 0],

    border: 0,
    borderTop: `solid ${borderWidth}px ${borderColor}`,
  },
};
